"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgMaterial = exports.CheckBox = exports.CardTable = exports.OverlayBar = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    height: ", ";\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n", "\n  font-size: ", "px !important;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  border-top: none;\n  border-bottom-right-radius: ", "px;\n  border-bottom-left-radius: ", "px;\n  position: relative;\n  overflow: hidden;\n  display: ", ";\n  box-shadow: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  z-index: 1;\n  background-color: ", ";\n  left: 77px;\n  padding-top: ", "px;\n  padding-left: ", "px;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var OverlayBar = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.palette.white.main;
}, function (props) {
  return props.theme.spacing(2);
}, function (props) {
  return props.theme.spacing(4);
});

exports.OverlayBar = OverlayBar;

var CardTable = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.theme.palette.white.main;
}, function (props) {
  return props.theme.shape.borderRadius;
}, function (props) {
  return props.theme.shape.borderRadius;
}, function (props) {
  return props.showTable ? 'block' : 'none';
}, function (props) {
  return "0 0 0 1px ".concat(props.theme.palette.black.lightest, ", 0 2px 4px 0 ").concat(props.theme.palette.black.lightest, ", 0 2px 1px 0 ").concat(props.theme.palette.black.lighter, ";");
});

exports.CardTable = CardTable;
var CheckBox = (0, _styledComponents["default"])(_Icon["default"])(_templateObject3(), function (props) {
  return props.theme.spacing(3);
}, function (props) {
  return props.theme.spacing(3);
});
exports.CheckBox = CheckBox;

var AgMaterial = _styledComponents["default"].div(_templateObject4(), function (_ref) {
  var tableHeight = _ref.tableHeight;
  return tableHeight && (0, _styledComponents.css)(_templateObject5(), tableHeight);
}, function (props) {
  return props.theme.typography.fontSize;
});

exports.AgMaterial = AgMaterial;